<template>
  <div class="report-icon" v-if="isShow" v-click-outside="closeBody">
    <div class="header" @click="open = !open">
      <img src="/img/icon_bug_report_outer.svg" alt="outer" />
      <img src="/img/icon_bug_report_inner.svg" alt="inner" />
    </div>
    <div class="body" v-if="open === true">
      <a href="https://forms.gle/kn448zzJiBGY7tuc6" target="_blank">
        의견 보내기
      </a>
      <a
        href="https://www.notion.so/treeD-Studio-v2-0-0-ea6cbb9d13744550bac3f855f7ce49ed"
        target="_blank"
      >
        사용 가이드
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      open: false,
    };
  },
  computed: {
    isShow() {
      // operator(R04) or crowdworker(R05) 일때만 show true
      const role = this.$store.getters.auth.userData.role;
      return ["R04", "R05"].includes(role);
    },
  },
  methods: {
    openBody() {
      this.open = true;
    },
    closeBody() {
      this.open = false;
    },
  },
};
</script>

<style>
.report-icon {
  position: fixed;
  bottom: 100px;
  left: 0;
  cursor: pointer;
  z-index: 99999;
}

.report-icon .header {
  width: 42px;
  height: 42px;
  border-radius: 0 50% 50% 0;
  background-color: #333333;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
}

.report-icon .header img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
}

.report-icon .body {
  width: 200px;
  height: 80px;
  background-color: #333333;
  position: absolute;
  top: -90px;
  left: 10px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.report-icon .body a {
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  padding-left: 10px;
  transition: 0.2s;
}

.report-icon .body a:hover {
  background-color: #000000;
}
</style>
